<template>
    <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
</template>

<script>
import ProcessosServicos from './ProcessosServicos'

export default {
    data() {
        return {
            faseContrato: {},
            erros: []
        }
    },

    methods: {
        obterFaseContratoGestor() {
            this.$store.dispatch('addRequest')
            let contratoId = this.$route.query.c
            let faseId = this.$route.query.f
            ProcessosServicos.obterFaseContratoGestor(contratoId, faseId).then(response => {
                if (response) {
                    if (response.success) {
                        this.faseContrato = response.data
                        this.confirmarFinalizarAvisosVencimentoFaseContrato()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        confirmarFinalizarAvisosVencimentoFaseContrato() {
            this.$swal({
                title: 'Avisos de Vencimento de Fase do Contrato',
                html: `Confirma a finalização dos avisos de vencimento da fase <b>${this.faseContrato.descricao}</b> de tipo <b>${this.faseContrato.tipoFaseContrato}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.finalizarAvisosVencimentoFaseContrato(result.value)
                } else {
                    this.$router.push('/')
                }
            })
        },

        finalizarAvisosVencimentoFaseContrato() {
            this.$store.dispatch('addRequest')
            let finalizarDto = {
                idContrato: this.$route.query.c,
                vencimento: this.$route.query.v,
                idFase: this.$route.query.f
            }
            ProcessosServicos.finalizarAvisosVencimentoFaseContrato(
                finalizarDto
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.finalizacaoRealizadaComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        finalizacaoRealizadaComSucesso() {
            this.$swal({
                title: 'Avisos de Vencimento de Fase do Contrato',
                html: `Finalizados com Sucesso`,
                icon: 'success'
            }).then(result => {
                if (result.value) {
                    this.$router.push('/')
                }
            })
        }
    },

    created() {
        this.obterFaseContratoGestor()
    }
}
</script>
